import * as React from "react";
const SvgFiRrFireSmoke = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-fire-smoke_svg__a)">
      <path
        fill="#062147"
        d="m20.19 15.06.008-.05A6.02 6.02 0 0 0 15 11.999c-.966 0-1.893.231-2.756.686a.51.51 0 0 1-.487 0 5.898 5.898 0 0 0-7.93 2.371 4.48 4.48 0 0 0-3.819 4.716C.148 22.143 2.206 24 4.692 24h14.615c2.486 0 4.544-1.857 4.684-4.228a4.474 4.474 0 0 0-3.802-4.711zm-.882 6.939H4.693c-1.405 0-2.61-1.052-2.688-2.346a2.485 2.485 0 0 1 2.12-2.618c.58-.087 1.08-.452 1.412-1.027a4.01 4.01 0 0 1 3.464-2.009c.637 0 1.25.153 1.824.456a2.52 2.52 0 0 0 2.352 0A3.9 3.9 0 0 1 15.001 14c1.424 0 2.752.77 3.465 2.008.331.575.832.94 1.412 1.027a2.485 2.485 0 0 1 2.12 2.618c-.078 1.294-1.285 2.346-2.69 2.346M5.016 9.428c-.002-.141-.013-.283-.013-.427V8.98c0-3.879 2.483-5.36 2.483-5.36a.77.77 0 0 1 .417-.135c.438 0 .793.355.793.792 0 .245-.194.519-.194.973 0 .828.481 1.75 1.76 1.75 1.277 0 1.74-.922 1.74-1.75 0-1-1-1.454-1-2.954 0-.435.19-1.339.404-1.753.181-.35.536-.544.9-.544.193 0 .39.055.564.169l.94.886c.28.263.571.515.882.74 1.23.892 4.301 3.492 4.31 7.196v.011q0 .258-.02.51c-.053.704-.759 1.187-1.412.918-.889-.367-.57-1.439-.57-1.439-.006-2.835-2.668-4.986-3.484-5.577l-.033-.024c.36.65.75 1.623.348 2.983-.463 1.565-1.968 2.637-3.599 2.627-1.409-.008-2.43-.633-3.045-1.516a5.9 5.9 0 0 0-.183 1.496c0 .427.203 1.123-.485 1.423s-1.492-.044-1.502-.975z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-fire-smoke_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFireSmoke;
